<form class="container">
  <h1>Lernkarten erfolgreich erstellt</h1>

  <div *ngIf="flashcards" class="flashcard-list">
    <app-flashcard-widget *ngFor="let flashcard of flashcards" [flashcard]="flashcard" (actionClicked)="handleFlashcardAction(flashcard, $event)"></app-flashcard-widget>
  </div>

  <div class="buttons-container">
    <div class="total-count">
      <i-tabler name="cards"></i-tabler>{{flashcards?.length}} Lernkarten
    </div>
    <div class="buttons">
      <app-button [text]="'misc.back' | translate" (clickEvent)="goBack()" [style]="'outlined'"></app-button>
      <app-button [text]="isDemo ? 'Lernkarten speichern' : 'Alle übernehmen'" (clickEvent)="saveFlashcards()" [loading]="isLoading"></app-button>
    </div>
  </div>
</form>